module.exports = __webpack_public_path__ + "img/dark_brown.c9bad117.svg";